export default {
	name: 'setting-management',
	path: '/setting-management',
	redirect: '/setting-management/permission',
	meta: {
		title: '设置管理',
		icon: 'icon-setting-management'
	},
	children: [
		{
			name: 'setting-permission',
			path: 'permission',
			fullPath: '/setting-management/permission',
			meta: {
				title: '权限管理'
			},
			component: () =>
				import(/*webpackChunkName: "setting-management"*/ '@/views/setting-management/permission')
		},
		{
			name: 'setting-management-role',
			path: 'role',
			fullPath: '/setting-management/role',
			meta: {
				title: '角色管理'
			},
			component: () =>
				import(/*webpackChunkName: "setting-management"*/ '@/views/setting-management/role')
		},
		{
			name: 'menu',
			path: 'menu-configure',
			fullPath: '/setting-management/menu-configure',
			meta: {
				title: '菜单管理'
			},
			component: () =>
				import(/* webpackChunkName: "setting-management" */ '@/views/setting-management/menu-configure')
		}
	]
};
